import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { SettingsEmail } from '../../../../shared/services/settings/settings.service';

export const settingsEmailActions = createActionGroup({
  source: 'Settings Email',
  events: {
    'load settings email': emptyProps(),
    'load settings email success': props<{ settings: SettingsEmail }>(),
    'load settings email failure': props<{ error: string }>(),

    'update settings email': props<{ dto: Partial<SettingsEmail> }>(),
    'update settings email success': props<{ settings: SettingsEmail }>(),
    'update settings email failure': props<{ error: string }>(),

    'connect google': props<{ dto: Partial<SettingsEmail>; state?: string }>(),
    'connect google failure': props<{ error: string }>(),

    'exchange google code': props<{ code: string }>(),
    'exchange google code success': props<{ settings: SettingsEmail }>(),
    'exchange google code failure': props<{ error: string }>(),
  },
});
